/**------------------------------------------------------
 * Event Names / Codes
 */
export enum EnumEventTheme {
	Birthday 		= 'birthday',
	Christmas 		= 'christmas',
	NewYear 		= 'new_year',
	Halloween 		= 'halloween',
	Eastern 		= 'eastern'
}
